<template>
    <div class="container-fluid">
        <video-manager-options
            :selectedVideosLength="selectedVideosLength"
            @changeFilter="filterVideo = $event"
			@changeDisplay="displayOptions = $event"
			@removeVideoSelection="removeVideoSelection"
			@deleteVideosSelected="deleteVideosSelected(selectedVideos)"
			@selectAllVideos="selectAllVideos()"
            @addVideo="addVideo($event)"
            @removeSelectedVideos="removeSelectedVideos()"
			@inSearch="inSearch = $event"
        />

        <div :class="['listImages mt-16rem', !hasResults ? 'd-flex justify-content-center align-items-center listImages--none' : '']">
			<template v-if="displayOptions === 'icons'">
                    <masonry-display
						:masonryId="videosMasonryGrid"
						:media="videos"
						:isSelected="isSelected"
						:inGallery="inGallery"
						:manageMedia="manageVideo"
						:deleteMedia="deleteVideo"
                        :nameFormated="nameFormated"
                        @copyVideoLink="copyVideoUrl"
                    />
                </template>

                <template v-else>
                    <table-display
						v-if="hasResults"
						:items="videos"
                        :selectedMedias="selectedVideos"
                        :selectedMediasLength="selectedVideosLength"
                        :deleteMedia="deleteVideo"
                        :manageMedia="manageVideo"
                        :isSelected="isSelected"
                        @copyVideoLink="copyVideoUrl"
					/>
                </template>

				<template v-if="!hasResults">
                    <empty-search-results :message="messageNotResult" :sub-message="subMessageNotResult" />
                </template>

            <template v-if="getNextMediaUrlVideos" >
                <infinite-loading @infinite="infiniteHandler" spinner="bubbles"></infinite-loading>
            </template>
        </div>

		<div class="container-button">
			<button
				class="btn btn-primario btn-extra-large"
				id="videoManagerButton"
				:disabled="validateButton()"
				@click="sendVideo()"
			>
				Adicionar
			</button>
		</div>
    </div>
</template>


<script>
import FileProgress from "@/components/organisms/FileProgress";
import InfiniteLoading from 'vue-infinite-loading';
import baseImage from "@/components/atoms/BaseImage";
import alertScreen from "@/components/molecules/AlertScreen";
import userModule from "../../store/modules/userModule.js";

import uploadFiles from "@/mixins/uploadFiles";
import apiMixins, { getPresignedS3Url } from "@/mixins/apiMixins";
import {mapGetters} from "vuex";
import { Dashboard } from '@uppy/vue'

import VideoManagerOptions from '../atoms/VideoManagerOptions.vue'
import MasonryDisplay from '../atoms/MasonryDisplay.vue';
import TableDisplay from '../atoms/TableDisplay.vue';
import EmptySearchResults from '../blocks/EmptySearchResults.vue';

export default {
    name: 'VideoManager',
    components: {
        Dashboard,
		baseImage,
		InfiniteLoading,
		FileProgress,
		alertScreen,
        VideoManagerOptions,
        MasonryDisplay,
		TableDisplay,
		EmptySearchResults
    },
	inject: ['picsInGallery'],
    data() {
        return {
			inSearch: false,
			messageNotResult: '',
			subMessageNotResult: '',
            selectedVideos: [],
            videosMasonryGrid: 'videosMasonryGrid',
            hasResults: true,
            filterVideo: 'created_at-desc',
            displayOptions: 'icons',
            videosInGallery: [],
        }
    },
  	mixins: [uploadFiles, apiMixins],
    methods: {
        makeToast(variant = null, title, content, ) {
            this.$bvToast.toast(content, {
                title,
                variant: variant,
                solid: true
            })
        },
        copyVideoUrl(item) {
            const copyToClipboard = async (string) => {
                await navigator.clipboard.writeText(string);
            };

            const link = item.embed;

            // copia para o clipboard
            try {
                copyToClipboard(link);
                this.makeToast('success', 'Sucesso', 'Link copiado para a área de transferência.');
            } catch (error) {
                this.makeToast('danger', 'Erro', 'Falha ao copiar link, tente novamente.');
            }
        },
		removeVideoSelection() {
            this.selectedVideos = [];
        },
        removeSelectedVideos() {
            this.selectedVideos = [];
        },
        getVideos() {
			let token = this.$session.get("jwt");
			let siteId = this.$session.get("siteId");

			this.$store.dispatch("userModule/FILTERS_VIDEOS", [token, siteId, '', this.filterVideo]);
		},
        addVideo(video) {
            this.selectedVideos.push(video);
        },
        deleteVideo(post, index) {
			this.$bvModal
				.msgBoxConfirm("Deseja remover este item do gerenciador de mídias?", {
					modalClass: "full-white modal-delete-medias",
					size: "md",
					buttonSize: "sm",
					okTitle: "Excluir",
					cancelTitle: "Cancelar",
					footerClass: "p-2",
					hideHeaderClose: true,
					centered: true,
				})
				.then(async (value) => {
					if (value) {
						this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);


						var response = await this.deleteMedias([post]);

						if (response) {
							this.$store.state.userModule.mediaManager.videos.splice(index, 1);

							this.selectedVideos.filter( (video) => {
								if (video.id == post.id) {
									this.selectedVideos.splice(this.selectedVideos.indexOf(video), 1);
								}
							});
						}

						this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
					}
				});

		},
		async deleteVideosSelected(videos) {
			let message = this.selectedVideosLength > 1 ? `Excluir ${this.selectedVideosLength} mídias selecionadas?` : `Excluir 1 mídia selecionada?`;

			const modal = this.$bvModal
				.msgBoxConfirm(message, {
					modalClass: "full-white modal-delete-medias",
					size: "md",
					buttonSize: "sm",
					cancelVariant: "danger",
					okTitle: "Excluir",
					cancelTitle: "Cancelar",
					footerClass: "p-2",
					hideHeaderClose: true,
					centered: true,
				})
				.then(async (value) => {
					if (value) {
						this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);

						var response = await this.deleteMedias(videos);

						if (response) {
							videos.forEach((video) => {
								this.$store.state.userModule.mediaManager.videos.filter((item) => {
									if (item.content == video.url) {
										this.$store.state.userModule.mediaManager.videos.splice(this.$store.state.userModule.mediaManager.videos.indexOf(item), 1);
									}
								});
							});

							this.selectedVideos = [];
						}

						this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
					}
				});
		},
		selectAllVideos() {
			this.videos.forEach((video) => {
				this.selectedVideos.push({
					'id': video.id,
					'url': video.content,
					'name': video.name,
					'embed': video.embed,
					'dataCreate': video.datetime,
					'index': this.videos.indexOf(video)
				});
			});
		},
        manageVideo(post, index) {
			let res = this.selectedVideos.findIndex(video => video.url == post.content);

			if (res >= 0) {
				this.selectedVideos.splice(res, 1);
			} else {
				this.selectedVideos.push({
					'id': post.id,
					'url': post.content,
					'name': post.name,
					'embed': post.embed,
					'dataCreate': post.datetime,
					'index': index
				});
			}
		},
        inGallery(url) {
			if (this.videosInGallery) {
				let res = this.videosInGallery.findIndex(img => img == url);
				if (res >= 0) {
					return true;
				} else {
					return false;
				}
			}
		},
        isSelected(url) {
			let res = this.selectedVideos.findIndex(video => video.url == url);
			if (res >= 0) {
				return true;
			} else {
				return false;
			}
		},
        async infiniteHandler($state) {
            if (this.getNextMediaUrlVideos) {
                const newVideos = await this.requestApiData( this.getNextMediaUrlVideos,  'get');

                if (newVideos.content.length > 0) {
                    this.$store.dispatch("userModule/UPDATE_VIDEOS", [newVideos]);

                    setTimeout(() => {
                        $state.loaded();
                    }, 1000);
                } else {
                    this.$store.dispatch("userModule/END_VIDEOS", false)
                }
            } else {
                $state.complete();
            }
		},
		nameFormated(name) {
			let nameFormated;

			if (window.innerWidth < 768) {
				nameFormated = name.length > 15 ? name.substr(0,10) + '...' : name;
			} else {
				nameFormated = name.length > 25 ? name.substr(0,20) + '...' : name;
			}

			return nameFormated;
		},
		validateButton() {
			if (this.selectedVideosLength > 0) return false;
			return true;
		},
		sendVideo() {
			// pegando componente pai (hierarquia de renderização) do VideoMager
			let tab = this.$parent

			// pegando componente pai (hierarquia de renderização) do Tab
			let tabs = tab.$parent

			// pegando componente pai (hierarquia de renderização) do Tabs
			let headerBTab = tabs.$parent

			// pegando componente pai (hierarquia de renderização) do HeaderBTab
			let mediaManager = headerBTab.$parent

			// Emitindo evento diretamente pelo componente MediaManager
            mediaManager.$emit("dataVideo", this.selectedVideos);
		},
		picsPosted(picsInGallery) {
			this.videosInGallery = picsInGallery && picsInGallery.map(item => {
				const url = item.image ? item.image.url : item.mainImage;
				return url;
			});
		},
    },
    watch: {
        filterVideo(newValue, oldValue) {
            newValue !== oldValue && this.getVideos();
        },
		videos(value) {
            if (this.videos !== '' && value.length > 0) {
				this.hasResults = true;
			} else if (this.videos !== '' && value.length == 0 && this.inSearch == true) {
                this.hasResults = false;
				this.messageNotResult = 'Nenhum resultado encontrado';
				this.subMessageNotResult = 'Experimente palavras-chave diferentes';
            } else if (this.videos !== '' && value.length == 0 && this.inSearch == false) {
				this.hasResults = false;
				this.messageNotResult = 'Você não possui vídeos ainda';
				this.subMessageNotResult = 'Copie e cole o link do vídeo no campo acima';
			}
        }
    },
    computed: {
        ...mapGetters("userModule", [
			"getMediaManagerMedias",
			"getMediaManagerMediasVideos",
			"getMediaManagerFilterOptions",
			"getNextMediaUrl",
			"getNextMediaUrlVideos",
			"getMediaManagerStatus",
			"getMediaManagerLoading",
			"setNextMediaUrl",
		]),
        videos() {
            return this.getMediaManagerMediasVideos;
		},
		selectedVideosLength() {
            return this.selectedVideos.length;
        },
    },
    mounted() {
        this.getVideos();

        setInterval(() => {
            this.$redrawVueMasonry();
        }, 1000)

		this.picsPosted && this.picsPosted(this.picsInGallery);
    }
}
</script>

<style scoped>
.listImages--none {
    height: 60vh;
}

:root {
    --mediaManagerTheme: #7e7e7e;
}

.uppy-Dashboard-AddFiles-title {
    position: relative;
    color: #7e7e7e;
}

.uppy-Root {
	top: 5px !important;
}

.uppy-Dashboard-AddFiles-title::before {
    content: url("../../assets/cloud-arrow-icon.svg");
    display: block;
    position: absolute;
    height: 22px;
    width: 32px;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
}

button.uppy-Dashboard-browse {
    padding-top: 40px;
    color: #7e7e7e;
    transition: 200ms ease-out;
}
button.uppy-Dashboard-browse:hover {
    color: rgba(34, 117, 215, 0.9);
    transition: 200ms ease-in;
}

.fade-in{-webkit-animation:fade-in 2s cubic-bezier(.39,.575,.565,1.000) both;animation:fade-in 2s cubic-bezier(.39,.575,.565,1.000) both}
@-webkit-keyframes fade-in{0%{opacity:0}100%{opacity:1}}@keyframes fade-in{0%{opacity:0}100%{opacity:1}}

#gutter-sizer {
    width: 0.6%;
}

.grid-item {
    width: 16%;
	border: none !important;
    margin-bottom: 12px;
}

.post-foto img {
	border-radius: 4px;
	cursor: pointer;
}

.post-foto .name-image-container {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	background-color: rgb(0, 0, 0, 0.4);
	border-radius: 1rem;
	margin: 0.5rem;
}

.post-foto .name-image-container span {
	font-size: 0.7rem;
	padding: 0.2rem 0.5rem;
}

.post-foto:hover .name-image-container {
	display: none !important;
}

.post-foto .delete-image-container {
	display: none;
}

.post-foto:hover .delete-image-container {
	display: block !important;
}

@media screen and (max-width: 576px) {
	#grid-sizer {
        width: 50%;
    };

	.listImages--none {
		height: 70vh;
	}
}

.mt-16rem {
    margin-top: 16.5rem;
}

.container-button {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 20px 10px;
	display: flex;
	justify-content: center;
	align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/VideoManager.vue